import 'twin.macro';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';

interface Props {
  onBackButtonClick: () => void;
  title: string;
}

export function Header({ onBackButtonClick, title }: Props) {
  return (
    <div tw="w-full p-4 flex flex-col gap-2.5">
      <div tw="flex items-center justify-between pb-2 pt-3">
        <div tw="flex">
          <Button
            onClick={onBackButtonClick}
            minimal
            intent="none"
            icon={ArrowLeftIcon}
            aria-label="Retour"
          />
        </div>
        <div tw="flex-1 flex justify-center">
          <h1 tw="display">{title}</h1>
        </div>
      </div>
    </div>
  );
}
